const pop_vote = {
  value: -25,
  settings: {
    decimalPlace: 1,
    title: "Popular Vote (%)",
    subtitle: "",
    maxValue: 25,
    minValue: -25,
    unit: "%"
  },
  options: {
    staticLabels: {
      labels: [-25, 0, 25],
      color: "black",
      fractionDigits: 0,
      unit: "%",
      font: "12pt Roboto"
    },
    staticZones: [{
        strokeStyle: "#ac1c00",
        min: -25,
        max: 0
      },
      {
        strokeStyle: "#6582b2",
        min: 0,
        max: 25
      }
    ]
  }
};

const senate_control = {
  value: 41,
  settings: {
    decimalPlace: 1,
    title: "Senate Control (seats)",
    subtitle: "",
    maxValue: 60,
    minValue: 40,
    unit: ""
  },
  options: {
    staticLabels: {
      labels: [40, 50, 50, 57, 60],
      color: "black",
      fractionDigits: 0,
      font: "12pt Roboto"
    },
    staticZones: [
      {
        strokeStyle: "#ac1c00",
        min: 40,
        max: 50
      },
      {
        strokeStyle: "#1c4587",
        min: 50,
        max: 50
      },
      {
        strokeStyle: "cornflowerblue",
        min: 50,
        max: 57
      },
      {
        strokeStyle: "#1c4587",
        min: 57,
        max: 60
      }
    ]
  }
};
const generic_ballot = {
  value: -30,
  settings: {
    decimalPlace: 1,
    title: "Generic Ballot (%)",
    subtitle: "",
    maxValue: 30,
    minValue: -30,
    unit: "%"
  },
  options: {
    staticLabels: {
      labels: [-30, 0, 30],
      color: "black",
      fractionDigits: 0,
      unit: "%",
      font: "12pt Roboto"
    },
    staticZones: [{
        strokeStyle: "#ac1c00",
        min: -30,
        max: 0
      },
      {
        strokeStyle: "#6582b2",
        min: 0,
        max: 30
      }
    ]
  }
}

const betting_wh = {
  value: 0,
  settings: {
    decimalPlace: 1,
    title: "White House Odds",
    subtitle: "",
    maxValue: 100,
    minValue: 0,
    unit: "%"
  },
  options: {
    staticLabels: {
      labels: [0, 100],
      color: "black",
      fractionDigits: 0,
      font: "12pt Roboto"
    },
    staticZones: [{
        strokeStyle: "#ac1c00",
        min: 0,
        max: 50
      },
      {
        strokeStyle: "#6582b2",
        min: 50,
        max: 100
      }
    ]
  }
};

const betting_senate = {
  value: 0,
  settings: {
    decimalPlace: 1,
    title: "Senate Majority Odds",
    subtitle: "",
    maxValue: 100,
    minValue: 0,
    unit: "%"
  },
  options: {
    staticLabels: {
      labels: [0, 100],
      color: "black",
      fractionDigits: 0,
      font: "12pt Roboto"
    },
    staticZones: [{
        strokeStyle: "#ac1c00",
        min: 0,
        max: 50
      },
      {
        strokeStyle: "#6582b2",
        min: 50,
        max: 100
      }
    ]
  }
};

const betting_house = {
  value: 0,
  settings: {
    decimalPlace: 1,
    title: "House Majority Odds",
    subtitle: "",
    maxValue: 100,
    minValue: 0,
    unit: "%"
  },
  options: {
    staticLabels: {
      labels: [0, 100],
      color: "black",
      fractionDigits: 0,
      font: "12pt Roboto"
    },
    staticZones: [{
        strokeStyle: "#ac1c00",
        min: 0,
        max: 50
      },
      {
        strokeStyle: "#6582b2",
        min: 50,
        max: 100
      }
    ]
  }
};


const models_538 = {
  value: 0,
  settings: {
    decimalPlace: 1,
    title: "538 Model: Presidental Election",
    subtitle: "",
    maxValue: 100,
    minValue: 0,
    unit: "%"
  },
  options: {
    staticLabels: {
      labels: [0, 100],
      color: "black",
      fractionDigits: 0,
      font: "12pt Roboto"
    },
    staticZones: [{
        strokeStyle: "#ac1c00",
        min: 0,
        max: 50
      },
      {
        strokeStyle: "#6582b2",
        min: 50,
        max: 100
      }
    ]
  }
};
module.exports = {
  pop_vote,
  senate_control,
  generic_ballot,
  betting_wh,
  betting_senate,
  betting_house,
  models_538
};
